import styled from 'styled-components'
import posed from 'react-pose'

import STYLE_CONSTANTS from '~/style/constants'

const Animation = posed.button({
  opened: {
    y: 0,
    transition: {
      duration: 100
    },
    opacity: 1
  },
  closed: {
    y: -10,
    transition: {
      duration: 100
    },
    opacity: 0
  }
})

const MenuItem = styled(Animation)`
  width: 75px;
  height: 25px;
  border: solid 1px
    ${props =>
      props.serious
        ? props.theme.colors.error
        : STYLE_CONSTANTS.colors.text.buttonGray};
  color: ${props =>
    props.serious
      ? props.theme.colors.error
      : STYLE_CONSTANTS.colors.text.buttonGray};
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  font-size: 0.75rem;
  border-radius: 3px;
  margin: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.5s ease;
  user-select: none;
  background: white;
  &:hover {
    color: white;
    background-color: ${props =>
      props.serious
        ? props.theme.colors.error
        : STYLE_CONSTANTS.colors.text.buttonGray};
  }
`

export default MenuItem
